<template>
  <div class="go-in">
    <banner :img="bannerImg" title="关于我们" titleEng="About Us" />
    <div class="section" v-loading="loading" >
      <div class="section-content" :style="{backgroundImage: `url(${bgContent})`}">
        <div class="content-summary">
          <div class="summary-left">
            <p class="title animate__animated animate__fadeInLeft">公司简介</p>
            <p class="eTitle animate__animated animate__fadeInLeft">ABOUT US</p>
            <p class="content animate__animated animate__zoomIn" v-html="article.htmlContent">
            </p>
          </div>
          <div class="summary-right">
            <!-- <img src="../assets/img/jianjietopmin.jpg" alt /> -->
            <img :src="article.coverImg" alt="">
          </div>
        </div>
        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>
        <!-- 发展历程 -->
        <!-- <div class="content-course">
          <div class="top">
            <h3>发展历程</h3>
            <p>DEVELOPMENT</p>
            <div class="border"></div>
            <div class="timeline"></div>
          </div>
          <div class="course-time">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item,index) in courseList" :key="index">
                <div class="time-show">
                  <div class="time-show-item" v-for="(courseOne,one) in item" :key="one">
                    <div class="item-top" :class="{'order-top' : one%2===1}"></div>
                    <el-divider>
                      <i class="el-icon-mobile-phone"></i>
                    </el-divider>
                    <div class="item-bottom" :class="{'order' : one%2===1}">
                      <div class="item-bottom-content">
                        <p>{{courseOne.title}}</p>
                        <p style="font-size: 22px;color: #ffd38e;">{{courseOne.occurenceTime}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div> -->

        <!-- <div class="content-culture">
          <h3>企业文化</h3>
          <h3>CULTURE</h3>
          <p>我们只专注一件事情——工程项目管理</p>
          <span>确保工程无重大安全事故</span>
          <span>确保工程施工单位无大面积返工</span>
          <span>确保工程材料及设备无伪劣产品</span>
          <span>确保工程管理留下痕迹、实施过程可追溯</span>
        </div> -->
        <!-- 公司荣誉 -->
        <div class="content-honor" >
          <!-- <div class="honor-big-img"> -->
            <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible" width="1000px">
              <img class="img-honor" v-lazy="dialogUrl" alt />
            </el-dialog>
          <!-- </div> -->
          <div class="top">
            <h3>公司荣誉</h3>
            <p>HONOR</p>
            <div class="border"></div>
          </div>
          <ul class="honor-show">
            <li v-for="(honor,index) in honorList" :key="index" :style="{height: (index < 9 || index > 14) ? '440px' : '220px'}">
              <img
                :src="honor.coverImg"
                @click="dialogUrl = honor.coverImg;dialogTableVisible = true ;dialogTitle= honor.title"
              />
            </li>
          </ul>
          <p>点击图片查看大图</p>
        </div>
        <!-- 团队风采 -->
        <div class="content-team">
          <div class="top">
            <h3>团队风采</h3>
            <p>TEAM</p>
          </div>
          <el-carousel :interval="4000" type="card">
            <el-carousel-item v-for="(team,index) in teamItem" :key="index">
              <img class="swiper-img" :src="team.coverImg" alt="">
              <!-- <div class="swiper-img" v-lazy:background-image="team.coverImg"></div> -->
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 合作伙伴 -->
        <div class="content-partner">
          <div class="top">
            <h3>合作伙伴</h3>
            <p>PARTNERS</p>
            <ul class="partner-img">
              <li v-for="(partner,i) in partnerImg" :key="i">
                <img :src="partner.coverImg" alt />
                <div style="text-align: center;font-weight: bold;margin-top: 8px;">{{ partner.title }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
// import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getArticleByCateId,getWebsiteConfigList } from '../api';
export default {
  components: {
    Banner,
    // swiper,
    // swiperSlide
  },
  data() {
    return {
      loading: false,
      honorList: [],
      partnerImg: [],
      courseList: [
        [

          // {title: '参加新创业大赛',occurenceTime: '2019-5'},
          // {title: '登录上海股权',occurenceTime: '2019-6'}
        ]
      ],
      teamItem: [],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: "",
      article: {},
      bgContent: '',
      bannerImg: ''
    };
  },
  created() {
    getArticleByCateId({cateId: '1'}).then(res => {
      // getArticleDetail(res.data[0].id).then(re => {
      //   this.article = re.data
      // })
      this.article = res.data.find(item => item.code === 'about_intro')
      this.honorList = res.data.filter(item => item.code === 'about_honor')
      this.teamItem = res.data.filter(item => item.code == 'about_team')
      this.partnerImg = res.data.filter(item => item.code == 'about_partner')
      // let list = res.data.filter(item => item.title !== '关于我们').sort((a,b) => {
      //   return Number(a.occurenceTime.slice(0,4)) - Number(b.occurenceTime.slice(0,4))
      // })
      // list.forEach((item,i) => {
      //   item.occurenceTime = item.occurenceTime.slice(0,4)
      //   if (i%2 === 0) {
      //     this.$set(this.courseList, i/2, [])
      //     this.$set(this.courseList[i/2], 0, item)
      //   } else {
      //     this.$set(this.courseList[(i-1)/2], 1, item)
      //   }
      // });
    })
    getWebsiteConfigList().then(res => {
      this.bgContent = res.data.some(item => item.code === 'bg_about') ? res.data.find(item => item.code === 'bg_about').title : ''
      this.bannerImg = res.data.some(item => item.code === 'bg_banner_about') ? res.data.find(item => item.code === 'bg_banner_about').title : ''
    })
  },
  mounted() {
    // this.$http
    //   .all([
    //     this.$http.get("Honor/GetHonorAll"),
    //     this.$http.get("Enterprise/GetEnterpriseAll"),
    //     this.$http.get(`Team/GetTeamAll`),
    //     this.$http.get(`Course/GetCourseAll`)
    //   ])
    //   .then(
    //     this.$http.spread(
    //       (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
    //         this.honorList = responseHonor.data;
    //         this.partnerImg = responseEnterprise.data;
    //         this.teamItem = responseTeam.data;

    //         var groupCount = Math.ceil(responseCourse.data.length / 2);
    //         window.console.log(groupCount);
    //         for (let i = 0; i < groupCount; i++) {
    //           let img2 = [];
    //           for (let j = 0; j < 2; j++) {
    //             if (responseCourse.data.length - 1 >= i * 2 + j) {
    //               img2.push(responseCourse.data[i * 2 + j]);
    //             }
    //           }
    //           this.courseList.push(img2);
    //         }
    //         window.console.log(this.courseList);
    //         this.loading = false;
    //       }
    //     )
    //   );
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  position: relative;
  overflow: hidden;
  .section {
    // width: 100%;
    &-content {
      width: 1300px;
      margin: 0 auto;
      background-color: #fff;

      .content-summary {
        //height: 500px;
        display: flex;
        justify-content: center;
        padding: 40px 50px 100px;
        .summary-left {
          width: 900px;
          margin-right: 100px;
          .title {
            font-size: 25px;
            color: #3e466b;
            font-weight: 500;
          }
          .eTitle {
            font-size: 16px;
            color: #3e466b;
            padding: 8px 0;
            font-weight: 400;
            margin-bottom: 24px;
          }
          .content {
            color: #333;
            font-size: 14px;
            // text-indent: 25px;
            line-height: 30px;
            text-align: justify;
          }
        }

        .summary-right {
          width: 400px;
          height: 310px;
          // border: 2px solid #1d42b9;
          //animation: imgboxkey 4s infinite;
          border-radius: 10px;
          margin-top: 80px;
          text-align: center;
          object-fit: cover;

          img {
            width: 410px;
            // height: 270px;
            margin-top: 20px;
            animation: imgbo 4s infinite linear;
          }
          @keyframes imgbo {
            0% {
                -webkit-transform: scale(1);
                        transform: scale(1);
                -webkit-box-shadow: 0px 0px 0px 0px #ababab;
                        box-shadow: 0px 0px 0px 0px #ababab;
            }
            50% {
                -webkit-transform: scale(1.1);
                        transform: scale(1.1);
                -webkit-box-shadow: 0px 0px 10px 5px #ababab;
                        box-shadow: 0px 0px 10px 5px #ababab;
            }
            100% {
                -webkit-transform: scale(1);
                        transform: scale(1);
                -webkit-box-shadow: 0px 0px 0px 0px #ababab;
                        box-shadow: 0px 0px 0px 0px #ababab;
            }
            }
        }
      }

      //发展历程
      .content-course {
        padding: 50px 0;
        .course-time {
          width: 1000px;
          height: 400px;
          margin: 20px auto;
          .swiper-container {
            height: 100%;
          }
          .time-show {
            width: 700px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;

              .item-top,
              .item-bottom {
                height: 190px;
              }
              .item-bottom {
                // display: flex;
                // align-content: center;
                .item-bottom-content {
                  background-color: #1667a0;
                  margin: 20px 0;
                  p {
                    color: #fff;
                    text-align: center;
                    padding: 15px;
                    // font-size: 20px;
                  }
                }
              }
            }
          }
        }
      }

      //企业文化
      .content-culture {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: #c2daeb;
        h3 {
          color: #3c6088;
          font-size: 26px;
        }
        p {
          color: #3c6088;
          font-size: 26px;
          padding: 5px 0;
        }
        span {
          font-weight: 400;
          line-height: 36px;
          font-size: 18px;
          padding: 5px 0;
        }
      }

      //公司荣誉
      .content-honor {
        padding: 50px 130px;
        .honor-show {
          // width: 1300px;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          li {
            width: 320px;
            height: 220px;
            margin-left: 15px;
            margin-top: 12px;
            list-style: none;
            border: 1px solid palegoldenrod;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
        p {
          text-align: center;
          color: #3c6088;
        }
      }

      //团队风采
      .content-team {
        padding: 50px 100px;
        .swiper-img {
          height: 400px;
          background: no-repeat center;
          background-size: cover;
          object-fit: cover;
        }
      }

      //合作伙伴
      .content-partner {
        padding: 50px 0;
        .partner-img {
          width: 950px;
          margin: 20px auto;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          li {
            width: 107px;
            height: 107px;
            list-style: none;
            margin: 10px 25px;

            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgb(194, 218, 235);
            }
          }
        }
      }
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  //background-color: #14679f;
}
.el-dialog__wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  ::v-deep {

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }

}

@media screen and (max-width: 997px) {
  .go-in {
    .section-content {
      width: calc(100% - 30px);
      .content-summary {
        padding: 40px 0;
        flex-wrap: wrap;
        .summary-left {
          width: calc(100% - 24px);
          margin: 0 auto !important;
        }
        .summary-right {
          width: calc(100% - 20px);
          img {
            width: 300px;
          }
        }
      }
      .content-honor {
        width: calc(100% - 16px);
        padding: 10px;
      }
      .content-team {
        padding: 10px;
      }
      .content-partner {
        .partner-img {
          width: 280px;
          overflow-x: auto;
          overflow-y: hidden;
          margin: 0 auto;
          padding-bottom: 25px;
          li {
            width: 50px;
            height: 50px;
            margin: 20px 10px;

            div {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  ::v-deep {
    .el-dialog {
      width: calc(100% - 20px) !important;
    }
  }
  .img-honor {
    width: calc(100% - 10px);
  }
}
</style>